import { render, staticRenderFns } from "./CityNav.vue?vue&type=template&id=5b4f05c8&scoped=true&"
import script from "./CityNav.vue?vue&type=script&lang=js&"
export * from "./CityNav.vue?vue&type=script&lang=js&"
import style0 from "./CityNav.vue?vue&type=style&index=0&id=5b4f05c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f05c8",
  null
  
)

export default component.exports